/**
 * Load a workspace's changes since its last sync (git sync Stage 1, card 7
 * set 7b): bring the mirror up to date (the same flush a sync does first),
 * then read what differs from HEAD as Apiboo items (mirrorChanges.js).
 */
import { mirrorAbsDir } from '../workspaceMirror';
import { refreshMirror } from '../workspaceGitSync';
import { readMirrorChanges } from './mirrorChanges';
import { useGitSyncStore } from '../../store/gitSyncStore';

/**
 * @returns {Promise<{ items: import('./changeItems').ChangeItem[], files: Array }>}
 *   `files` keeps the raw before/after text for "Show file diff".
 */
export async function loadGitChanges(workspace, snapshot) {
  if (!workspace?.git) return { items: [], files: [] };
  await refreshMirror(workspace, snapshot);
  const dir = (await mirrorAbsDir(workspace.id)).replace(/\\/g, '/');
  const { items, files } = await readMirrorChanges(dir);
  useGitSyncStore.getState().setChangeCount(String(workspace.id), items.length);
  return { items, files };
}
